import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "@emotion/styled"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Intro = styled.p`
  font-size: 1.2rem;
  line-height: 1.7;
  margin-bottom: 2.5rem;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2.5rem 2rem;
  margin-bottom: 2rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const Card = styled.figure`
  margin: 0;
`

const Caption = styled.figcaption`
  font-style: italic;
  font-size: 0.95rem;
  color: #666;
  margin-top: 0.6rem;
`

const captions = {
  IMG_9242: "Exploring shapes that I like. This rim on this one feels playful.",
  IMG_9322: "Just got out of bisque firing! Feels like Christmas morning.",
  IMG_0178:
    "Formulated an ultraviolet glaze today, here are the test tiles on different clay bodies.",
  IMG_9435:
    "A good friend gifted me a donut from CDMX, saved the box and gifted her one of these for her birthday.",
  IMG_9955: "Experimenting with ripples on walls.",
  IMG_9426: "Can't believe these came from my hands and my mind :o",
  IMG_0180: "Leaving surprises for potters who love looking underneath pieces!",
  IMG_0039:
    "Gasped when I saw this on the glaze shelf. My favorite glaze experiment thus far!",
  IMG_9329:
    "Gambled a little with this red velvet clay + a runny nebula blue glaze. Worth it!",
}

const order = [
  "IMG_9242",
  "IMG_9322",
  "IMG_0178",
  "IMG_9435",
  "IMG_9955",
  "IMG_9426",
  "IMG_0180",
  "IMG_0039",
  "IMG_9329",
]

const PotteryPage = () => {
  const data = useStaticQuery(graphql`
    query PotteryImages {
      allFile(filter: { relativeDirectory: { eq: "pottery" } }) {
        edges {
          node {
            name
            childImageSharp {
              fluid(maxWidth: 900, quality: 85) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  const images = order
    .map((name) => data.allFile.edges.find(({ node }) => node.name === name))
    .filter(Boolean)

  return (
    <Layout>
      <SEO title="Pottery" />
      <h1>Questions, in Clay</h1>
      <Intro>
        Pottery is the clearest place I know to practice starting over. Every
        pull on the wheel is a small correction on the last one; every glaze
        test is a guess informed by the guess before it. I don't believe
        understanding arrives all at once. I think it accumulates through
        repeated encounters with reality. Here are some of mine:
      </Intro>
      <Grid>
        {images.map(({ node }) => (
          <Card key={node.name}>
            <Img fluid={node.childImageSharp.fluid} alt={captions[node.name]} />
            <Caption>{captions[node.name]}</Caption>
          </Card>
        ))}
      </Grid>
    </Layout>
  )
}

export default PotteryPage
